import { jsx as s } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { Root as a } from "./styles.js";
const m = (o) => o.href !== void 0, f = e(
  ({ children: o, ...t }, r) => m(t) ? /* @__PURE__ */ s(a, { as: "a", ...t, ref: r, children: o }) : /* @__PURE__ */ s(a, { type: "button", ...t, ref: r, children: o })
);
f.displayName = "Pressable";
export {
  f as Pressable,
  m as isAnchor
};
//# sourceMappingURL=index.js.map
